/** Raster wordmarks in `public/logo/` (tight crop, no square canvas). */
export const WORDMARK_INTRINSIC = { width: 870, height: 194 } as const;

export const wordmark = {
  light: "/logo/Blue.png",
  dark: "/logo/Tetiary.png",
  black: "/logo/Black.png",
  white: "/logo/White.png",
} as const;

/** JSON-LD / metadata: same as light UI (blue on white). */
export const wordmarkSchemaUrlPath = wordmark.light;

/**
 * Logomark (folded W) in `public/logo/`, tight crop: glyph plus a 2-unit margin.
 * Light: navy + tonal step. Dark: the same inverted palette as `wordmark.dark` (Tetiary).
 */
export const LOGOMARK_INTRINSIC = { width: 88, height: 60 } as const;

export const logomark = {
  light: "/logo/mark-light.svg",
  dark: "/logo/mark-dark.svg",
} as const;
